import React from "react";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogTitle, CircularProgress } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import TrailerHook from "../TrailerHook";
import TrailerDrop from "../TrailerDrop";
import { Drop_Hook_Move_Page_Names } from "../../constants";
import { getPageDetails, getDollyOptions } from "../utils";
import MoveBills from "../MoveBills";
import styles from "./styles";
import { observer, inject } from "mobx-react";
import { getDataWithQueryString } from "../../../../../../api/componentAPIs";
import Events from "../../../../../../utilities/EventEmitter";
import appConstants from "../../../../../../appConstants";
import { getTrailerStatusesAllowedToHook, getTrailerStatusesAllowedToMoveBills, getDollyStatusesAllowedToHook } from "../MoveBills/utils";
import DollyHook from "../DollyHook";
import { withAppConfig } from "../../../../../../appConfigContext";

@inject("DispatchStore")
@observer
class DropHookMoveDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
      trailerList: [],
      dollyList: [],
    };
  }

  componentDidMount() {
    this.getAllTrailerDetails();
    this.getAllDollyDetails();
    Events.on("RefreshTrailersData", this.getAllTrailerDetails);
    Events.on("refreshDolly", this.getAllDollyDetails);
  }
  componentWillUnmount() {
    Events.off("RefreshTrailersData", this.getAllTrailerDetails);
    Events.off("refreshDolly", this.getAllDollyDetails);
  }

  showHideLoader = (value) => {
    this.setState({
      showLoader: value,
    });
  };

  setPageName = (pageName) => {
    this.setState({
      pageName,
    });
  };

  handleBack = () => {
    this.setState({
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    });
  };

  onClose = () => {
    if (this.state.showLoader) {
      return;
    }
    this.setState({
      pageName: Drop_Hook_Move_Page_Names.DROP_HOOK_MOVE,
    });
    this.props.handleClose();
  };

  getAllTrailerDetails = () => {
    getDataWithQueryString(
      "GetAllEquipment",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&equipmentType=${appConstants.EQUIPMENT_TYPES.Trailer}`
    ).then((allEquipmentRes) => {
      if (allEquipmentRes?.status === 200) {
        this.setState({
          trailerList: allEquipmentRes.data?.trailer ?? [],
        });
      } else {
        this.setState({
          trailerList: [],
        });
      }
    });
  };

  getAllowedTrailerStatuses = (clientCodes) => {
    const { trailerStatusConfig = [], dollyStatusConfig = [] } = clientCodes ?? {};
      return {
        allowedTrailerStatusesToMoveBills: getTrailerStatusesAllowedToMoveBills(trailerStatusConfig),
        allowedTrailerStatusesToHook : getTrailerStatusesAllowedToHook(trailerStatusConfig),
        allowedDollyStatusesToHook : getDollyStatusesAllowedToHook(dollyStatusConfig)
      };
  }
  getAllDollyDetails = () => {
    getDataWithQueryString(
      "GetAllEquipment",
      `terminalCode=${this.props.userData.userProfile.terminal.code}&equipmentType=${appConstants.EQUIPMENT_TYPES.Dolly}`
    ).then((allEquipmentRes) => {
      if (allEquipmentRes?.status === 200) {
        this.setState({
          dollyList: allEquipmentRes.data?.dolly ?? [],
        });
      } else {
        this.setState({
          dollyList: [],
        });
      }
    });
  };

  render() {
    const {
      classes,
      open,
      routeData,
      currentDriverRoutes,
      configJSON: { showTrailerScac, enableDollyDropAndHook }
    } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    const { showLoader, pageName, trailerList, dollyList } = this.state;
    const { isDropHookPage, isTrailerDropFormPage, isSelectShipmentPage } =
      getPageDetails(pageName);
    const clientCodes =
      this.props.DispatchStore.getStaticClientData()?.clientCodes;
    const { allowedTrailerStatusesToMoveBills, allowedTrailerStatusesToHook, allowedDollyStatusesToHook } =
      this.getAllowedTrailerStatuses(clientCodes);
    const maxAllowedEquipmentCount = this.props.DispatchStore.maxAllowedTrailerCount;
    const maxAllowedDolliesCount= maxAllowedEquipmentCount - 1;
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="drop-hook-move-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${theme}`}>
          <DialogTitle
            disableTypography
            handleClose={this.onClose}
            id="drop-hook-move-title"
            classes={{ root: classes.dialogTitle }}>
            <span className={classes.dialogTitleText}>
              {!isDropHookPage ? (
                <IconButton
                  aria-label="close"
                  className={classes.backButton}
                  onClick={this.handleBack}>
                  <ArrowBack />
                </IconButton>
              ) : null}
              {isTrailerDropFormPage && enableDollyDropAndHook ? "Equipment Drop" :pageName}
            </span>
            <IconButton aria-label="close" className={classes.closeButton} onClick={this.onClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={`customScroll ${classes.dialogContent}`}>
            {isDropHookPage || isTrailerDropFormPage ? (
              <TrailerDrop
                showTrailerScac={showTrailerScac}
                routeData={routeData}
                currentDriverRoutes={currentDriverRoutes}
                isTrailerDropFormPage={isTrailerDropFormPage}
                setPageName={this.setPageName}
                showHideLoader={this.showHideLoader}
                isLoading={showLoader}
                enableDollyDropAndHook={enableDollyDropAndHook}
              />
            ) : null}
            {isDropHookPage ? (
              <>
                <TrailerHook
                  showTrailerScac={showTrailerScac}
                  routeData={routeData}
                  currentDriverRoutes={currentDriverRoutes}
                  showHideLoader={this.showHideLoader}
                  isLoading={showLoader}
                  trailerList={trailerList ?? []}
                  maxAllowedTrailerCount={maxAllowedEquipmentCount}
                  allowedTrailerStatusesToHook={allowedTrailerStatusesToHook}
                />
                {enableDollyDropAndHook && (
                  <DollyHook
                    routeData={routeData}
                    showHideLoader={this.showHideLoader}
                    currentDriverRoutes={currentDriverRoutes}
                    isLoading={showLoader}
                    dollyListOptions={getDollyOptions(dollyList, showTrailerScac)}
                    maxAllowedDolliesCount={maxAllowedDolliesCount}
                    allowedDollyStatusesToHook={allowedDollyStatusesToHook}
                  />
                )}
              </>
            ) : null}
            {(isDropHookPage || isSelectShipmentPage) && (
              <MoveBills
                userProfile={this.props.userData.userProfile}
                routeData={routeData}
                currentDriverRoutes={currentDriverRoutes}
                isSectionDisabled={!currentDriverRoutes.length}
                isSelectShipmentPage={isSelectShipmentPage}
                setPageName={this.setPageName}
                onClose={this.props.handleClose}
                trailerList={trailerList ?? []}
                allowedTrailerStatusesToMoveBills={allowedTrailerStatusesToMoveBills}
              />
            )}
          </DialogContent>
          {showLoader ? (
            <div className={classes.loader}>
              <CircularProgress size={30} />
            </div>
          ) : null}
        </Dialog>
      </React.Fragment>
    );
  }
}

export default compose(withUserProfile, withAppConfig, withStyles(styles))(DropHookMoveDialog);
